const baseURL = {
  dev: 'https:/www.jtgj.cc',
  prod: 'https:/www.jtgj.cc',
  imageUrl:'https:/www.jtgj.cc'
}

export default baseURL;